module.exports = __webpack_public_path__ + "static/img/img18.fbee3e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c39/img18.png
// module id = Tvot
// module chunks = 0